import { default as locale } from 'date-fns__legacy__/locale/pt'
import distanceInWordsStrict from 'date-fns__legacy__/distance_in_words_strict'
import parse from 'date-fns__legacy__/parse'
import {format, parseISO} from 'date-fns'

const parseExpiration = (expirationDate) => {
  const today = new Date
  const expiration = parse(expirationDate)

  return distanceInWordsStrict(today, expiration, { locale })
}

const formatDate = (data: any) => {
  const formatedDate = format(parseISO(data), 'dd/MM/yyyy')
  return formatedDate
}


/**
 * @param {ApiWalletBoletoRecharge} data
 * @returns {WalletBoleto}
 */
export const parseRechargeBoleto = (data, amount) => ({
  url: data.boletoUrl,
  barcode: data.boletoBarcode,
  expiration: parseExpiration(data.expirationDate),
  amount: amount,
  status: null,
})

/**
 * @param {ApiWalletBoletoPending} data
 * @returns {WalletBoleto}
 */
export const parsePendingBoleto = (data) => ({
  id: data.walletExtractId,
  url: data.boletoUrl,
  barcode: data.boletoBarcode,
  expiration: parseExpiration(data.expirationDate),
  amount: data.amount,
  status: data.status,
})

export const parsePendingPix = (data) => ({
  id: data.walletExtractId,
  url: data.qrCode,
  copyPasteCode: data.copyPasteCode,
  date: formatDate(data.expirationDate),
  expiration: parseExpiration(data.expirationDate),
  amount: data.amount,
  status: data.status,
})

export default {
  parseRechargeBoleto,
  parsePendingBoleto,
}